import type { BusinessSegment, ClientAccess, ClientAccessDto } from '../types';
import { BUSINESS_SEGMENTS } from '../types';

export const NO_CLIENT_ACCESS: ClientAccess = {
  employee: { view: false, edit: false },
  workplace: { view: false, edit: false },
};

// A login payload of an older session has no `client_access`; it then grants
// nothing until the token is refreshed.
export function clientAccessFromDto(
  access: Partial<ClientAccessDto> | null | undefined,
): ClientAccess {
  return {
    employee: { ...NO_CLIENT_ACCESS.employee, ...access?.employee },
    workplace: { ...NO_CLIENT_ACCESS.workplace, ...access?.workplace },
  };
}

export function viewableSegments(access: ClientAccess): BusinessSegment[] {
  return BUSINESS_SEGMENTS.filter((segment) => access[segment].view);
}

export function editableSegments(access: ClientAccess): BusinessSegment[] {
  return BUSINESS_SEGMENTS.filter((segment) => access[segment].edit);
}
